import styled from "styled-components";
import { Link } from "react-router-dom";
import Sns from "components/templates/signUp/Footer/Sns";
import logo from "assets/images/footer/logo.png";

const Footer = () => {
  return (
    <footer className="bg-primary-active py-15 px-8 md:p-8">
      <Inner>
        <h1 className="flex-none">
          <img src={logo} alt="" width={95} className="md:w-[55px]" />
        </h1>
        <div className="flex-1 flex flex-col gap-y-5">
          <p className="flex items-center gap-2 font-bold">
            <Link to="/terms" target="_blank">
              이용약관
            </Link>
            <Line />
            <Link to="/privacy-policy" target="_blank">
              개인정보처리방침
            </Link>
          </p>
          <Info>
            <strong>법인명</strong> : (주) 스페이스시프트・
            <strong>대표자</strong> : 이동훈
            <span className="lg:hidden">・</span>
            <br className="tablet" />
            <strong>사업자 등록번호</strong> : 293-88-02438・
            <strong>개인정보보호책임자</strong> : 이준희
            <br />
            <strong>주소</strong> : 서울특별시 영등포구 양평로21길 26, 805호
            <span className="lg:hidden">・</span>
            <br className="tablet" />
            <strong>T</strong> : 02-3456-7117・<strong>F</strong>: 02-3456-7118
            <span className="lg:hidden">・</span>
            <br className="tablet" />
            <strong>E</strong> : spaceshift.kr@gmail.com
          </Info>
          <div className="md:flex md:items-center md:gap-8">
            <p>©2023 Macodi. All rights reserved.</p>
            <div className="hidden md:block">
              <Sns />
            </div>
          </div>
        </div>
        <div className="absolute right-8 md:hidden">
          <Sns />
        </div>
      </Inner>
    </footer>
  );
};

const Inner = styled.div`
  max-width: 1340px;
  margin: 0 auto;
  display: flex;
  gap: 60px;

  p,
  a,
  span,
  strong {
    color: #fff;
    font-size: 14px;
    line-height: 20px;
  }

  @media screen and (max-width: 767px) {
    flex-direction: column;
    gap: 20px;

    p,
    a,
    span,
    strong {
      font-size: 12px;
    }
  }
`;

const Line = styled.span`
  display: block;
  width: 1px;
  height: 11px;
  background: #fff;
`;

const Info = styled.p`
  strong {
    font-weight: bold;
  }

  .tablet {
    display: none;
  }

  @media screen and (max-width: 1023px) {
    .tablet {
      display: block;
    }
  }
`;

export default Footer;
